import { Tag } from "antd";
import { useI18n, type MessageKey } from "@/i18n";

/** Physical condition of stock (Plan §6.2). Only sellable stock is sold. */
export type Condition = "sellable" | "damaged" | "quarantine";

export const conditions: Condition[] = ["sellable", "damaged", "quarantine"];

export const conditionOptions = (t: (k: MessageKey) => string) => conditions.map((c) => ({ value: c, label: t(`inventory.condition.${c}`) }));

export function ConditionTag({ condition }: { condition: Condition }) {
  const { t } = useI18n();
  const color = condition === "damaged" ? "error" : condition === "quarantine" ? "warning" : undefined;
  return <Tag color={color}>{t(`inventory.condition.${condition}`)}</Tag>;
}
